import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { Subject } from 'rxjs';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { positiveIntegerWithMaxValidatorBuilder } from '../../../common/utils/number-validator';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

interface StepOption {
  name: string;
  id: string;
}

@Component({
  selector: 'automata-jump-panel',
  templateUrl: './jump-panel.component.html',
  styleUrls: ['./jump-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
  ],
})
export class JumpPanelComponent extends CommonActionPanelComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  private destroyed$$ = new Subject<void>();

  stepOptions: StepOption[] = [];

  ngOnInit(): void {
    super.ngOnInit();
    this.stepOptions = (this.automation.workflow || [])
      .filter((s) => !!s.name && s.id !== this.step?.id)
      .map((s) => ({ name: s.name, id: s.id }));

    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.form = new UntypedFormGroup({
      maxNumberOfJumps: new UntypedFormControl(
        jsonData.max_number_of_jumps || 1,
        positiveIntegerWithMaxValidatorBuilder(100),
      ),
      step: new UntypedFormControl(jsonData.step_to_jump_to, Validators.required),
    });
    this.savingEnabled = true;
  }

  ngOnDestroy(): void {
    this.destroyed$$.next();
    this.destroyed$$.complete();
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.form];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    if (!this.form) {
      return jsonData;
    }
    jsonData.max_number_of_jumps = this.form.controls.maxNumberOfJumps.value;
    jsonData.step_to_jump_to = this.form.controls.step.value;
    return jsonData;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  isFormValid(): boolean {
    return this.form.valid;
  }
}
